import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { DetailPolishOffRequest, DetailsOrderClimbRequest, OrderPolishOffRequest } from 'src/app/models/order.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { OrderService } from 'src/app/services/order.service';
import { VendorService } from 'src/app/services/vendor.service';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { ChartService } from 'src/app/services/chart.service';
import { ProductHistoryResponse } from 'src/app/models/product.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';

@Component({
  selector: 'app-modal-polish-off-order',
  templateUrl: './modal-polish-off-order.component.html',
  styleUrls: ['./modal-polish-off-order.component.scss']
})
export class ModalPolishOffOrderComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  @Input() orderShowed: any;
  anulating = false;
  saving = false;
  providers = [];
  timeout = null;
  downloading = false;
  orderProvider: { [key: number]: any } = {};
  seeing: { [key: number]: boolean } = {};
  warehouseObjects: { [key: number]: any } = {};
  companyName = "";
  totalDownload = 0;
  warehouses = [];
  month = null;
  percentage = 0.15;
  loadingItems = 0;
  locked = true;
  user = null;

  constructor(
    private orderService: OrderService,
    private toastService: ToastrService,
    private vendorService: VendorService,
    private templateService: TemplateInvoice,
    private authService: AuthenticationService,
    private productService: ProductService,
    private warehouseService: WarehouseService,
    private chartService: ChartService
  ) {
    this.companyName = JSON.parse(authService.getCurrentCompany()).companyName;
    this.user = JSON.parse(authService.getCurrentUser()).id;
    console.log(this.user);
    this.month = (new Date()).getMonth();
    var permissions = authService.getPermissions();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const permission = permissions[i];
        if (permission.roleId == 5040 && permission.create) {
          this.percentage = 0.3;
          break;
        }
      }
    }
  }

  getGradientColor(): string {
    const percentage = (this.loadingItems / this.orderShowed['items'].length * 100);
    return `linear-gradient(90deg, rgba(0,31,84,1) ${percentage}%, rgba(255,255,255,1)  ${percentage}%)`;
  }

  ngOnInit(): void {
    this.orderShowed['items'].forEach((i) => {
      this.warehouseObjects[i.productData.id] = {
        value: "",
        verified: false,
        required: false,
        filterElements: [],
        data: null,
        class: "",
        existence: "--",
        product: i.productData.id
      }
      this.productService.getHistoryProduct(i.productData.id, this.orderShowed.order.warehouse.id).subscribe({
        next: (response: ResponseObject) => {
          i['history'] = response.data;
          this.loadingItems++;
          response.data.forEach((d) => {
            var month = (new Date(d[0])).getMonth() + 1;
            if (month == this.month) {
              i['max'] = d[1] + d[1] * this.percentage;
              i['original'] = d[1];
            }
          });
          if (!i['max']) {
            if (this.percentage == 0.3) {
              i['max'] = Infinity;
              i['original'] = Infinity;
            } else {
              i['max'] = -1;
              i['original'] = -1;
              i['hasErrorMax'] = true;
              i['error'] = "ERROR: No se cuenta con un valor máximo";
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    })
    this.vendorService.getProvidesByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.providers = response.data;
        this.orderShowed['items'].forEach(element => {
          element['provider'].filterElements = response.data;
          element['existence'] = null;
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
    this.warehouseService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        if (this.orderShowed) {
          this.orderShowed['items'].forEach((i) => {
            this.warehouseObjects[i.productData.id] = {
              value: "",
              verified: false,
              required: false,
              filterElements: this.warehouses,
              data: null,
              class: "",
              existence: "--",
              product: i.productData.id
            }
          })
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  lockUnlock() {
    this.locked = !this.locked;
    this.orderShowed['items'].forEach((i) => {
      if (this.locked) {
        i['max'] = (i['original'] == Infinity) ? Infinity : i['original'] + i['original'] * this.percentage;
      } else {
        i['max'] = Infinity;
      }
      this.checkingPolishOff(null, i);
    });
  }

  writeWarehouse(input, product) {
    input.class = "typing";
    input.filterElements = this.warehouses.filter((w) => {
      return w.name.toLowerCase().includes(input.value.toLowerCase());
    });
    clearTimeout(this.timeout);
    if (input.filterElements.length == 0) {
      input.class = "fa-xmark";
      input.verified = false;
      input.data = null;
    } else if (input.filterElements.length == 1) {
      this.timeout = setTimeout(() => {
        this.selectWarehouse(input.filterElements[0], input, product);
      }, 1000);
    } else {
      input.class = "fa-list";
      input.verified = false;
      input.data = null;
    }
  }

  selectWarehouse(warehouse, input, product) {
    clearTimeout(this.timeout);
    input.value = warehouse.name;
    input.class = "fa-circle-check";
    input.verified = true;
    input.data = warehouse;
    this.productService.getExistence(warehouse.id, input.product).subscribe({
      next: (response: ResponseObject) => {
        if (response.data != undefined) {
          this.warehouseObjects[input.product].existence = response.data + "";
          product.existence = response.data;
        } else {
          this.warehouseObjects[input.product].existence = "--";
          product.existence = null;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  checkingPolishOff(event, product) {
    product.error = "";
    var errors;
    if (product.max) {
      if (product.max < product.polishOff) {
        if (product.max < 0) {
          errors = "No se cuenta con un valor máximo ";
        } else {
          errors = "Superado el máximo de " + Math.floor(product.max);
        }
        product.hasErrorMax = true;
      } else {
        product.hasErrorMax = false;
      }
    } else {
      product.hasErrorMax = false;
    }
    if (product.quantity < product.polishOff) {
      errors = (errors) ? errors + ' y la cantidad' : 'Superada la cantidad';
    }
    if (errors) {
      product.error = "ERROR:\n" + errors;
    }
  }

  anItemhasErrorMax() {
    for (let index = 0; index < this.orderShowed['items'].length; index++) {
      const item = this.orderShowed['items'][index];
      if (item.hasErrorMax) {
        return true;
      }
    }
    return false;
  }

  showOrHide(product: any) {
    var productId = product.productData.id;
    if (this.seeing[productId]) {
      delete this.seeing[productId];
    } else {
      this.seeing[productId] = true;
      setTimeout(() => {
        var dataPoints = product['history'];
        var months = [];
        var values = [];
        dataPoints.forEach((d) => {
          months.push(d[0]);
          values.push(d[1]);
        });
        const options = {
          chart: {
            height: 150,
            type: 'line'
          },
          title: {
            text: product.productData.name,
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: true,
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
              fontFamily: "Nunito",
              color: '#001f54'
            },
          },
          dataLabels: {
            enabled: true
          },
          stroke: {
            curve: 'smooth'
          },
          series: [{
            name: 'Despachados',
            data: values,
            color: '#001f54'
          }],
          xaxis: {
            type: 'Mes',
            categories: months,
          },
          legend: {
            show: false
          }
        }
        const chart = new ApexCharts(
          document.querySelector("#apex-spline-area-chart-" + productId),
          options
        );
        chart.render();
      })
    }
  }

  getUniqueProviderIds() {
    const uniqueProviderIds = new Set();
    this.orderShowed['items'].forEach(element => {
      if (element.provider.verified) {
        uniqueProviderIds.add(element.provider.data.id);
      }
    });
    return uniqueProviderIds.size;
  }

  downloadOrders() {
    this.downloading = true;
    this.orderProvider = {};
    this.orderShowed['items'].forEach(element => {
      if (this.orderProvider[element.provider.data.id] != undefined) {
        this.orderProvider[element.provider.data.id].items.push({ code: element.productData.code, description: element.productData.name, quantity: element.polishOff });
      } else {
        this.orderProvider[element.provider.data.id] = {
          nit: element.provider.data.nit,
          name: element.provider.data.name,
          warehouseName: this.orderShowed.order.warehouse.name,
          warehouseNit: this.orderShowed.order.warehouse.nit,
          warehouseAddress: this.orderShowed.order.warehouse.address,
          fcolor: this.orderShowed.order.warehouse.fcolor,
          scolor: this.orderShowed.order.warehouse.scolor,
          tcolor: this.orderShowed.order.warehouse.tcolor,
          nfact: this.orderShowed.order.warehouse.nfact,
          number: this.orderShowed.order.warehouse.number,
          id: this.orderShowed.orderId,
          date: this.convertToString(this.orderShowed.order.date),
          items: [{ code: element.productData.code, description: element.productData.name, quantity: element.polishOff }]
        }
      }
    });
    for (const key in this.orderProvider) {
      this.createInvoicePDF(this.orderProvider[key]);
      this.downloading = false;
    }
  }

  async createInvoicePDF(invoiceData: any) {
    var invoiceDataNew = this.getInvoiceData(invoiceData);
    if (invoiceData['nfact'] <= 0 || invoiceData['nfact'] > 5) {
      invoiceData['nfact'] = 1;
      invoiceData['fcolor'] = "#1D5073";
      invoiceData['scolor'] = "#CCCCCC";
      invoiceData['tcolor'] = "#CCCCCC";
      invoiceData['slogan'] = "";
    }
    invoiceDataNew['warehouse'] = { name: invoiceData.warehouseName, number: invoiceData.number, address: invoiceData.warehouseAddress }
    var configurationInvoice = { id: invoiceData['nfact'], fcolor: invoiceData['fcolor'], scolor: invoiceData['scolor'], tcolor: invoiceData['tcolor'], slogan: invoiceData['slogan'] };
    this.templateService.selectTemplate(configurationInvoice, invoiceDataNew, null);
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  getInvoiceData(invoice: any) {
    var templateGenerated = new InvoiceTemplateModel();
    templateGenerated.type = InvoiceType.PROVIDER;
    templateGenerated.client.name = (invoice.name) ? invoice.name : '';
    templateGenerated.client.nit = (invoice.nit) ? invoice.nit : '';
    templateGenerated.certifier.signature = '';
    templateGenerated.certifier.date = "";
    templateGenerated.certifier.nit = "";
    templateGenerated.certifier.data = "";
    templateGenerated.invoice.date = (invoice.date) ? invoice.date : "";
    templateGenerated.invoice.number = " " + invoice.id;
    templateGenerated.invoice.serial = "ORDEN " + (invoice.name).slice(0, 6).toUpperCase();
    templateGenerated.seller.city = (invoice.warehouseName) ? invoice.warehouseName : "";
    templateGenerated.seller.name = this.companyName;
    templateGenerated.seller.nit = (invoice.warehouseNit) ? invoice.warehouseNit : "";
    templateGenerated.seller.state = (invoice.number) ? "Tel. " + invoice.number : "";
    templateGenerated.seller.street = (invoice.warehouseAddress) ? invoice.warehouseAddress : "";
    templateGenerated.total = -1;
    invoice.items.forEach(element => {
      var temp = new InvoiceItemModel(element.quantity, -1, element.description);
      temp.code = element.code;
      templateGenerated.items.push(temp);
    });
    return templateGenerated;
  }

  disabledSave() {
    for (let i = 0; i < this.orderShowed['items'].length; i++) {
      const item = this.orderShowed['items'][i];
      if (item.quantity < item.polishOff) {
        return true;
      }
      if (!item['provider'].verified) {
        return true;
      }
    }
    return false;
  }

  writeProvider(inputValue: string, input: any) {
    input.class = "typing";
    input.filterElements = this.providers.filter((p) => {
      return p.nit == inputValue || p.name.toLowerCase().includes(inputValue.toLowerCase());
    });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (input.filterElements.length == 1) {
        this.selectProvider(input.filterElements[0], input);
      } else {
        var results = input.filterElements.length > 0;
        input.data = null;
        input.class = (results) ? "fa fa-list" : 'fa fa-xmark';
        input.verified = false;
      }
    }, 1000);
  }

  selectProvider(provider, input) {
    clearTimeout(this.timeout);
    input.data = provider;
    input.class = "fa fa-circle-check";
    input.verified = true;
    input.value = provider.nit + " - " + provider.name;
  }

  anulateOrder() {
    var newPolishOff = new OrderPolishOffRequest();
    newPolishOff.date = (new Date()).getTime();
    newPolishOff.isCancelled = true;
    newPolishOff.orderId = this.orderShowed['orderId'];
    this.orderShowed['items'].forEach(order => {
      newPolishOff.products.push(new DetailPolishOffRequest(order.id, order.productData.id, order['polishOff']));
    });
    this.anulating = true;
    this.orderService.polishOff(newPolishOff).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success(response.data);
        this.orderShowed = null;
        this.anulating = false;
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.anulating = false;
        this.toastService.error(error.error.message);
      }
    });
  }

  confirmChanges() {
    this.downloadOrders();
    this.saving = true;
    var newPolishOff = new OrderPolishOffRequest();
    newPolishOff.date = (new Date()).getTime();
    newPolishOff.isCancelled = false;
    newPolishOff.orderId = this.orderShowed['orderId'];
    var check = true;
    for (let i = 0; i < this.orderShowed['items'].length; i++) {
      const order = this.orderShowed['items'][i];
      if (order.quantity < order['polishOff']) {
        check = false;
      }
      newPolishOff.products.push(new DetailPolishOffRequest(order.id, order.productData.id, order['polishOff']));
    }
    if (check) {
      this.orderService.polishOff(newPolishOff).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success(response.data);
          this.orderShowed = null;
          this.saving = false;
          this.close.emit(true);
        },
        error: (error: HttpErrorResponse) => {
          this.saving = false;
          this.toastService.error(error.error.message);
        }
      });
    } else {
      this.toastService.error("Hay valores a despachar que superan la cantidad total");
      this.saving = false;
    }
  }

  confirmTranslate() {
    this.saving = true;
    var newClimbRequest = new DetailsOrderClimbRequest();
    newClimbRequest.userId = this.user;
    newClimbRequest.orderId = this.orderShowed.orderId;
    for (let index = 0; index < this.orderShowed['items'].length; index++) {
      const item = this.orderShowed['items'][index];
      if (item.hasErrorMax) {
        newClimbRequest.orderDetailId.push(item.id);
      }
    }
    this.orderService.climb(newClimbRequest).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se ha trasladado el pedido");
        this.orderShowed = null;
        this.saving = false;
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.saving = false;
        this.toastService.error(error.error.message);
      }
    });
  }

}
